import React from 'react';

import { BrandLink, BrandImg } from './style';

const Brand = () => (
  <BrandLink to="/">
    <BrandImg alt="Glassnode" src="/images/glassnode-studio.svg" />
  </BrandLink>
);

export default Brand;
